const rivers = "#253A7D";
const grass = "#34625A";
const road = "#3A485B";
const road2 = "#6A798E";

const mapTheme = [
  { main: "background", hexCode: grass },
  { main: "labelTextFill", hexCode: "#bdbdbd" },
  { main: "labelTextStroke", hexCode: grass },
  { main: "administrativeGeometry", hexCode: "#757575" },
  { main: "administrativeCountryLabelTextFill", hexCode: "#9e9e9e" },
  { main: "administrativeLocalityLabelTextFill", hexCode: "#bdbdbd" },
  { main: "poiTextFill", hexCode: "#757575" },
  { main: "poiParkGeometry", hexCode: "#ab9954" },
  { main: "poiParkLabelTextFill", hexCode: "#616161" },
  { main: "poiParkLabelTextStroke", hexCode: "#bdbdbd" },
  { main: "roadGeometryFill", hexCode: "#4F5B6C" },
  { main: "roadLabelTextFill", hexCode: "#bdbdbd" },
  { main: "roadArterialGeometry", hexCode: road },
  { main: "roadHighwayGeometry", hexCode: road2 },
  { main: "roadHighwayControlledAccessGeometry", hexCode: "#4e4e4e" },
  { main: "roadLocalLabelTextFill", hexCode: "#bdbdbd" },
  { main: "transitLabelTextFill", hexCode: "#757575" },
  { main: "waterGeometry", hexCode: rivers },
  { main: "waterLabelTextFill", hexCode: "#3054AC" },
];

export const mapStyles = [
  {
    elementType: "geometry",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "background")?.hexCode,
      },
    ],
  },
  {
    elementType: "labels.icon",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    elementType: "labels.text.fill",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "labelTextFill")
          ?.hexCode,
      },
    ],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "labelTextStroke")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "administrativeGeometry")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "administrative.country",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: mapTheme.find(
          (theme) => theme.main === "administrativeCountryLabelTextFill"
        )?.hexCode,
      },
    ],
  },
  {
    featureType: "administrative.land_parcel",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative.locality",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: mapTheme.find(
          (theme) => theme.main === "administrativeLocalityLabelTextFill"
        )?.hexCode,
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "poiTextFill")?.hexCode,
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "geometry",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "poiParkGeometry")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "poiParkLabelTextFill")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.stroke",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "poiParkLabelTextStroke")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "roadGeometryFill")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "roadLabelTextFill")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "geometry",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "roadArterialGeometry")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "roadHighwayGeometry")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "geometry",
    stylers: [
      {
        color: mapTheme.find(
          (theme) => theme.main === "roadHighwayControlledAccessGeometry"
        )?.hexCode,
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "roadLocalLabelTextFill")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "transitLabelTextFill")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "waterGeometry")
          ?.hexCode,
      },
    ],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [
      {
        color: mapTheme.find((theme) => theme.main === "waterLabelTextFill")
          ?.hexCode,
      },
    ],
  },
];
